export default {"src":"/_next/static/media/ribs.de70246d.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};